const idOf = file => String(file?.id || file?._id || '');

// File identity establishes the task and path. Filename-only matching can
// accidentally offer an unrelated task's README or budget as a revision.
export function latestWorkArtifactRevision(eventsByTask, sourceFile) {
  const sourceId = idOf(sourceFile);
  if (!sourceId) return null;
  for (const events of Object.values(eventsByTask || {})) {
    const original = events.find(event => event.type === 'artifact_ready' && idOf(event.artifact?.file) === sourceId);
    if (!original?.artifact?.path) continue;
    let latest = original;
    for (const event of events) {
      if (event.type === 'artifact_ready' && event.artifact?.path === original.artifact.path
        && idOf(event.artifact.file) && Number(event.seq) > Number(latest.seq)) latest = event;
    }
    return idOf(latest.artifact.file) !== sourceId ? latest.artifact : null;
  }
  return null;
}
